import { render, staticRenderFns } from "./ReduceBtn.vue?vue&type=template&id=f2d6f102&scoped=true&"
import script from "./ReduceBtn.vue?vue&type=script&lang=js&"
export * from "./ReduceBtn.vue?vue&type=script&lang=js&"
import style0 from "./ReduceBtn.vue?vue&type=style&index=0&id=f2d6f102&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d6f102",
  null
  
)

export default component.exports